import React, { useEffect, useState } from "react";
import SvgArrow from "../../../../assets/icons/SvgArrow";
import { Link, navigate } from "gatsby";
import QuickSlider from "./Slider";
import Details from "./Details";
import { useDatalayer } from "../../../../utils/useDatalayer";
import { DialogContent } from "@/components/ui/dialog";
import { UseMatchedColors } from "../../../../hooks/useMatchedColors";
import ProductRatingView from "../../../product/overview/Rating";
import ProductOverview from "./Overview";
import { getSelectedVariant2 } from "../../../../utils/getCurrentVariant";

const QuickView = ({ product, clubPrice }) => {
  const { viewProduct } = useDatalayer();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedColor, setSelectedColor] = useState({});
  const [currentVariant, setCurrentVariant] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState({
    selectedSize: "",
    selectedOpening: "",
    selectedPaymentMethod: "",
    selectedAmount: "",
    selectedLength: "",
    selectedFit: "",
    selectedStrength: "",
    selectedStyle: "",
    selectedCountry: "",
  });

  function handleChangeVariant(key, value) {
    setSelectedVariant({ ...selectedVariant, [key]: value });
  }

  const [colors] = UseMatchedColors(
    product.options.find(
      (option) => option.name === "Color" || option.name === "Colour"
    )?.values || [],
    product
  );

  useEffect(() => {
    if (!colors) {
      return;
    }
    let initialVariant = product.variants.find((variant) => {
      return variant.availableForSale;
    });
    if (!initialVariant) {
      [initialVariant] = product.variants;
    }

    let selectedOptions = selectedVariant;
    initialVariant.selectedOptions.forEach((selectedOption) => {
      if (selectedOption.name === "Color" || selectedOption.name === "Colour") {
        const variantColor = colors.find(
          (color) => color.name === selectedOption.value
        );
        if (variantColor) {
          setSelectedColor(variantColor);
        }
      }
      selectedOptions = {
        ...selectedOptions,
        [`selected${selectedOption.name}`]: selectedOption.value,
      };
    });

    setSelectedVariant(selectedOptions);
  }, [colors]);

  useEffect(() => {
    if (product?.variants?.length && selectedVariant) {
      const variant = getSelectedVariant2(
        selectedColor,
        selectedVariant,
        product?.variants
      );
      if (variant) {
        setCurrentVariant(variant);
      } else {
        setCurrentVariant(null);
      }
    }
  }, [selectedColor, selectedVariant]);

  useEffect(() => {
    if (product?.variants?.length && selectedColor) {
      const variant = product?.variants?.find((variant) =>
        String(variant.title)
          .toLowerCase()
          .includes(String(selectedColor?.name).toLowerCase())
      );

      if (variant?.media) {
        const index = product.media.findIndex(
          (image) =>
            image.preview.image.originalSrc ===
            variant?.media[0]?.preview.image.originalSrc
        );
        if (index !== -1) {
          setSelectedIndex(index);
        }
      } else {
        setSelectedIndex(0);
      }
    }
  }, [selectedColor]);

  function onVariantChange(variant) {
    viewProduct(product, variant);
  }

  return (
    <DialogContent
      overlay="hidden md:bg-black/20"
      className="flex flex-col overflow-y-scroll overflow-x-hidden max-h-[85%] max-w-[92%] px-[30px] pt-10 md:pt-20 pb-14 w-[calc(92%-(((92%-60px)/2)-500px))]"
    >
      <div className="flex flex-wrap items-start max-w-[1600px] mx-auto pb-[30px] lg:pb-[45px] box-border">
        <div className="md:hidden px-5 pb-4">
          <h1 className="pt-2 lg:pt-0 mb-2 text-lg leading-[30px] sm:text-xl md:text-[26px] md:leading-8 font-bold">
            {product.title}
          </h1>
          <div className="flex items-center cursor-pointer">
            <button
              onClick={() => navigate(`/products/${product.handle}`)}
              title="Product Rating"
              className="text-[13px] sm:font-bold leading-[17px] text-black/70 hover:text-gray-500
            transition-colors duration-200 ease-linear pp-no-hide"
            >
              <ProductRatingView
                reviewAverage={product.reviewsAverage?.value}
                reviewCount={product.reviewsCount?.value}
              />
            </button>
          </div>
          <ProductOverview handle={product.handle} />
        </div>
        <QuickSlider images={product.media} selectedIndex={selectedIndex} />
        <Details
          product={{ ...product, colors }}
          clubPrice={clubPrice}
          onVariantChange={onVariantChange}
          selectedVariant={selectedVariant}
          handleChangeVariant={handleChangeVariant}
          selectedColor={selectedColor}
          setSelectedColor={setSelectedColor}
          currentVariant={currentVariant}
        />
      </div>
      <hr className="my-[20px] w-full border-t border-solid border-t-gray-400" />
      <div className="flex justify-end py-[50px] px-[7%] w-full box-border">
        {/* <p className="font-bold text-base no-underline">
          Learn more about this Product
        </p> */}
        <Link
          className="text-center text-primary-500 flex items-center underline underline-offset-[3px] decoration-2 text-base font-bold tracking-wider leading-[25px]
          cursor-pointer hover:scale-105 transition-transform duration-200 ease-linear"
          to={`/products/${product?.handle}`}
        >
          <span className="mr-[10px]">Take me to the Product</span> <SvgArrow />
        </Link>
      </div>
    </DialogContent>
  );
};

export default React.memo(QuickView);
